module.exports = __webpack_public_path__ + "static/img/i4.f560273.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/eng/i4.png
// module id = pc2l
// module chunks = 0